import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQueryClient, useMutation } from 'react-query';

function useReorderEpisode(podcastId) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function reorderEpisode(data) {
    return privateFetch.put(`/v1/admin/podcast/${podcastId}/episodes/reorder`, data);
  }

  return useMutation(reorderEpisode, {
    onSuccess() {},
    onError(error) {
      console.error('Failed to reorder episodes:', error);
    },
    onSettled() {
      queryClient.invalidateQueries(['podcast-episode', podcastId]);
      queryClient.invalidateQueries(['podcast-reorder-episode', podcastId]);
    },
  });
}

export default useReorderEpisode;
